var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-grid-container",style:(_vm.gridStyle),attrs:{"id":"grid-container"}},_vm._l((_vm.allHours),function(hour,index){return _c('div',{key:index,class:{
      'g-grid-line': true,
      'g-grid-line-highlighted': _vm.highlightedHours.includes(hour)
    }})}),0)}
var staticRenderFns = []
export { render, staticRenderFns }